import type { LumxClassName } from '@lumx/core/js/types';

/**
 * Component display name.
 */
export const ITEM_COMPONENT_NAME = 'NavigationItem';

/**
 * Component default class name and class prefix.
 */
export const ITEM_CLASSNAME: LumxClassName<typeof ITEM_COMPONENT_NAME> = 'lumx-navigation-item';
